<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    switchFullscreen
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">
        <a-row>
          <a-col :xs="24" :sm="12">
            <mtc-form-item label="label.code" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheCode')"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <mtc-form-item label="label.description" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-popover placement="topLeft">
                <template slot="content" v-if="whetherLang('name')">
                  <div style="width: 200px;">
                    <a-row v-for="(item, index) in getMainTablePop('name')" :key="index">
                      <a-col :span="8" style="text-align:right;font-weight:bold;">{{item.langType}}：</a-col>
                      <a-col :span="16">{{item.langText}}</a-col>
                    </a-row>
                  </div>
                </template>
                <a-input v-decorator="['name', validatorRules.name]" :read-only="whetherLang('name')" @click="isLangClick('name', true)" :placeholder="$t('label.pleaseEnterADescription')"></a-input>
              </a-popover>
            </mtc-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <mtc-form-item label="label.applicableBusiness" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :triggerChange="true" dictCode="biz_type" v-decorator="['bizType',validatorRules.bizType]" />
            </mtc-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <mtc-form-item label="label.sort" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['seq', validatorRules.seq]" :placeholder="$t('label.pleaseEnterSort')"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <mtc-form-item label="label.remarks" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-popover placement="topLeft">
                <template slot="content" v-if="whetherLang('name')">
                  <div style="width: 200px;">
                    <a-row v-for="(item, index) in getMainTablePop('description')" :key="index">
                      <a-col :span="8" style="text-align:right;font-weight:bold;">{{item.langType}}：</a-col>
                      <a-col :span="16">{{item.langText}}</a-col>
                    </a-row>
                  </div>
                </template>
                <a-input v-decorator="['description', validatorRules.description]" :read-only="whetherLang('description')" @click="isLangClick('description', true)" :placeholder="$t('label.pleaseEnterANote')"></a-input>
              </a-popover>
            </mtc-form-item>
          </a-col>
<!--          <a-col :xs="24" :sm="12">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['notes']" placeholder="请输入备注，后台用"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :xs="24" :sm="12">
            <!--<a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
              <!--<a-radio-group v-decorator="['validFlag', { initialValue: 'Y' }]">-->
                <!--<a-radio value="Y">是</a-radio>-->
                <!--<a-radio value="N">否</a-radio>-->
              <!--</a-radio-group>-->
            <!--</a-form-item>-->
            <mtc-form-item label="label.whetherValid" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                v-decorator="['validFlag', {}]"
                :placeholder="$t('label.pleaseSelectWhetherSynchronizeWorkflowEngine')"
                :type="'radio'"
                :triggerChange="true"
                dictCode="valid_flag"
              />
            </mtc-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="明细" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="sysCodeRuleDtlTable.loading"
            :columns="sysCodeRuleDtlTable.columns"
            :dataSource="sysCodeRuleDtlTable.dataSource"
            :maxHeight="300"
            :subLangItems="subLangItems"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true"/>
        </a-tab-pane>

      </a-tabs>

    </a-spin>
  </j-modal>
</template>

<script>

  import pick from 'lodash.pick'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import {duplicateCheck} from "@api/api";
  import { MTC_AUTH } from '@api/servers'

  export default {
    name: 'SysCodeRuleModal',
    mixins: [JEditableTableMixin],
    components: {
      JDate,
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          code: { rules: [{ required: true, message: '请填写编码!' }] },
          bizType: { rules: [{ required: true, message: '请选择适用业务!' }] },
          name: { rules: [{ required: true, message: '请填写描述!' }] },
          seq: {
            rules: [
            { required: true, message: '请填写排序!' },
            { validator: this.validateRuleSeqOnly },
            ]
          },
          description: { rules: [{ required: true, message: '请填写备注!' }] },
        },
        refKeys: ['sysCodeRuleDtl', ],
        tableKeys:['sysCodeRuleDtl', ],
        activeKey: 'sysCodeRuleDtl',
        // sys_code_rule_dtl
        sysCodeRuleDtlTable: {
          loading: false,
          dataSource: [],
          columns: [
           /* {
              title: '关联主表ID',
              key: 'ruleId',
              type: FormTypes.input,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },*/
            /*{
              title: '关联主表编码',
              key: 'ruleCode',
              type: FormTypes.input,
              width:"150px",
              placeholder: '根据主表编码更新',
              defaultValue: '',
              disabled: true
            },*/
            {
              title: 'tableHeader.ruleType',
              key: 'ruleType',
              type: FormTypes.select,
              width:"150px",
              // placeholder: '请选择${title}',
              dictCode: 'rule_type',
              validateRules: [
                {
                  required: true,
                  message: '请选择${title}'
                }
              ]
            },
            {
              title: 'tableHeader.RuleValueFormat',
              key: 'ruleFormat',
              type: FormTypes.input,
              width:"150px",
              // placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: 'tableHeader.fillRule',
              key: 'fillRule',
              type: FormTypes.select,
              width:"150px",
              // placeholder: '请选择${title}',
              dictCode: 'fill_rule',
              defaultValue: '',
              validateRules: [
                {
                  required: true,
                  message: '请选择${title}'
                }
              ]
            },
            {
              title: 'tableHeader.fillChar',
              key: 'fillChar',
              type: FormTypes.input,
              width:"100px",
              // placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: 'tableHeader.length',
              key: 'fillLength',
              type: FormTypes.inputNumber,
              width:"100px",
              // placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: 'tableHeader.sort',
              key: 'seq',
              type: FormTypes.inputNumber,
              width:"100px",
              // placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [
                {
                  required: true,
                  // message: '请输入${title}'
                }
              ]
            },
            {
              title: 'tableHeader.remarks',
              key: 'description',
              type: FormTypes.input,
              width:"200px",
              // placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: 'tableHeader.whetherValid',
              key: 'validFlag',
                type: FormTypes.radio,
              width:"150px",
              // placeholder: '请输入${title}',
              defaultValue: '',
              options: [{text: this.$t('label.yes'),value: 'Y'},{text: this.$t('label.no'),value: 'N'}]
            },
          ]
        },
        url: {
          add: `${ MTC_AUTH }/system/sysCodeRule/addWithSysCodeRuleDtl`,
          edit: `${ MTC_AUTH }/ system/sysCodeRule/editWithSysCodeRuleDtl`,
          sysCodeRuleDtl: {
            list: `${ MTC_AUTH }/system/sysCodeRule/querySysCodeRuleDtlByMainId`
          },
          ruleType: null,
        },
        disableSubmit: true,
        mainTable: "sys_code_rule",
        subTable: "sys_code_rule_dtl",
      }
    },
    created() {

    },
    methods: {
      /** 校验主表排序的唯一性 */
      validateRuleSeqOnly(rule, value, callback) {
        // 校验主表排序重复
        var params = {
          tableName: 'sys_code_rule',
          fieldName: 'seq',
          fieldVal: value,
          dataId: this.model.id
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      },
      /** 校验子表排序的唯一性 */
      validateRuleDtlSeqOnly() {

      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'code','name','bizType','seq','description','createBy','createTime','updateBy','updateTime','sysOrgCode','notes','validFlag','tenantCode')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.sysCodeRuleDtl.list, params, this.sysCodeRuleDtlTable)
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        let values = allValues.tablesValue[0].values
        for (let i = 0; i < values.length; i++) {
          let sysLanguageList = []
          for (const key in this.subTableLangLists) {
            let rowIndex = key.split('_')[1]
            if (rowIndex == i) {
              for (let j = 0; j < this.subTableLangLists[key].length; j++) {
                sysLanguageList.push(this.subTableLangLists[key][j])
              }
            }
          }
          values[i]['sysLanguageList'] = sysLanguageList
        }
        return {
          ...main, // 展开
          sysCodeRuleDtlList: values,
          sysLanguageList: this.sysLanguageList
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','name','bizType','seq','description','createBy','createTime','updateBy','updateTime','sysOrgCode','notes','validFlag','tenantCode'))
      },
    }
  }
</script>

<style scoped>
</style>